
    var riot = require('riot')
    //src: starling/src/tags/notifications.html
riot.tag2('notifications',
  '<button class="Button Button--Plain Button--Icon {\'Button--Active no-tip\': isOpen}" data-tip="Recent activity" onclick="{toggleNotificationPanel}"> <span class="Button__Icon"> <svg class="Button__Icon"> <use xlink:href="#history-icon"></use> </svg> <span if="{hasUnseenNotifications()}" class="notifications_alert">*</span> </span> </button> <div class="notifications_panel" show="{isOpen}"> <h4 if="{!playbackInProgress}" class="notifications_header">Recent activity</h4> <ul if="{!playbackInProgress}" class="notifications_list" onwheel="{handleScroll}"> <li each="{getNotifications()}" class="notification {unseen && \'notification--active\'}" onmouseenter="{handleNotificationMouseEnter}" onmouseleave="{handleNotificationMouseLeave}" onclick="{handleNotificationClick}"> <i class="fa fa-circle notification_icon" aria-hidden="true" riot-style="{getUserStyle(user.id)};"></i> <span class="notification_summary"> {user.id === window.user_id ? \'You\' : user.display_name} {readableSummary} </span> <span class="notification_timestamp">{friendlyTime}</span> </li> </ul> <div class="notifications_footer"> <h4 class="notifications_footer_title">Playback recent changes</h4> <div class="notifications_controls"> <button if="{!playbackInProgress}" class="notifications_control" onclick="{handleStartPlayback}"> <svg class="notifications_control_icon"> <use xlink:href="#play-icon"></use> </svg> </button> <button if="{playbackInProgress}" class="notifications_control" onclick="{handlePausePlayback}"> <svg class="notifications_control_icon"> <use xlink:href="#pause-icon"></use> </svg> </button> <button if="{!playbackStopped}" class="notifications_control" onclick="{handleStopPlayback}"> <svg class="notifications_control_icon"> <use xlink:href="#stop-icon"></use> </svg> </button> <input ref="slider" class="input-range notifications_progress" type="range" oninput="{updateSlider}" min="-1" max="{hui.operationLog.length - 1}" step="1" riot-value="{playbackPointer}"> </div> </div> </div>',
  '',
  'show="{hasNotifications()}" class="notifications mrgn-l-4 hideWhenPresenting"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util');

var _historyUi = require('lib/history-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _commentsUi = require('lib/comments-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _opts = opts,
    canvas = _opts.canvas;

this.isOpen = false;
this.seenNotifications = false;
this.playbackPointer = -1;

this.playbackInProgress = false;
this.playbackPaused = false;
this.playbackStopped = true;
this.playbackDelayMilliseconds = 1200;

canvas.notificationsTag = this;

this.hasNotifications = function () {
  return _this.getNotifications() && _this.getNotifications().length;
};

this.hasUnseenNotifications = function () {
  if (!_this.hasNotifications()) return;
  if (_this.didSeeNotifications) return;
  return !!_this.getNotifications().find(function (_ref) {
    var unseen = _ref.unseen;
    return unseen;
  });
};

this.getNotifications = function () {
  return _historyUi.hui && _historyUi.hui.notifications && _historyUi.hui.notifications.slice(0).reverse();
};

this.toggleNotificationPanel = function () {
  var isOpen = _this.isOpen;

  _this.didSeeNotifications = true;

  if (isOpen) {
    _this.hideNotifications();
    _eventTracking2.default.track({
      category: 'Notifications',
      action: 'Playback',
      label: 'Hide Notifications'
    });
  } else {
    _this.showNotifications();
    _eventTracking2.default.track({
      category: 'Notifications',
      action: 'Playback',
      label: 'Open Notifications'
    });
  }
};

this.showNotifications = function () {
  _this.isOpen = true;
  _this.seenNotifications = true;
  _this.update();
};

this.hideNotifications = function () {
  _this.isOpen = false;
  _this.handleStopPlayback();
  _this.update();
};

this.handleNotificationMouseEnter = function (e) {
  _historyUi.hui.highlightElements(e.item.elements, e.item.user.id);
};

this.handleNotificationMouseLeave = function (e) {
  _historyUi.hui.unhighlightElements(e.item.elements);
};

this.handleNotificationClick = function (e) {
  var item = e.item;

  e.stopPropagation();

  _historyUi.hui.leavePlaybackMode();

  if (item.unseen) {
    item.unseen = false;
    _this.update();
  }

  if (!item.elements) return;

  var _hui$getNotificationE = _historyUi.hui.getNotificationElements(item),
      nodes = _hui$getNotificationE.nodes,
      links = _hui$getNotificationE.links,
      regions = _hui$getNotificationE.regions,
      comments = _hui$getNotificationE.comments;

  if (!nodes && !links && !regions && !comments) return;

  if (comments && comments.length) {
    return _commentsUi.commentsUI.panToComment(comments[0].id, true);
  }

  _this.triggeredZoom = true;
  canvas.centerContent({ nodes: nodes, links: links, regions: regions }, { animate: true });
  // avoid hiding this panel when clicking on an item
  setTimeout(function () {
    delete _this.triggeredZoom;
  }, 400);
};

this.getUserStyle = function (userId) {
  return 'color: ' + (0, _util.colorFromUserId)(userId);
};

this.handleStartPlayback = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
    var _playbackTimeout;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            e.stopPropagation();
            _historyUi.hui.enterPlaybackMode();

            if (_this.playbackPointer >= _historyUi.hui.operationLog.length - 1) {
              _this.playbackPointer = -1;
            }

            _context2.next = 5;
            return _historyUi.hui.shiftHistory({ to: _this.playbackPointer });

          case 5:

            _this.playbackInProgress = true;
            _this.playbackStopped = false;
            _this.playbackPaused = false;
            _this.update();

            _historyUi.hui.zoomToCurrentOperation();

            _playbackTimeout = function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!(_this.playbackPointer < _historyUi.hui.operationLog.length)) {
                          _context.next = 12;
                          break;
                        }

                        if (_this.playbackInProgress) {
                          _context.next = 4;
                          break;
                        }

                        if (_this.playbackStopped) {
                          _this.update();
                        }
                        return _context.abrupt('return');

                      case 4:
                        _this.playbackPointer++;
                        _this.update();
                        _context.next = 8;
                        return _historyUi.hui.shiftHistory({ to: _this.playbackPointer });

                      case 8:
                        appUI.freshen();
                        _historyUi.hui.zoomToCurrentOperation();
                        _this.playbackTimeout = setTimeout(_playbackTimeout, _this.playbackDelayMilliseconds);
                        return _context.abrupt('return');

                      case 12:

                        if (!_this.playbackPaused) {
                          _this.playbackInProgress = false;
                          _this.playbackStopped = true;
                          _historyUi.hui.leavePlaybackMode();
                          canvas.fitMapContents();
                        }

                      case 13:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function _playbackTimeout() {
                return _ref3.apply(this, arguments);
              };
            }();

            _this.playbackTimeout = setTimeout(_playbackTimeout, _this.playbackDelayMilliseconds);
            _eventTracking2.default.track({
              category: 'Notifications',
              action: 'Playback',
              label: 'Start Playback'
            });

          case 13:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

this.handlePausePlayback = function (e) {
  e.stopPropagation();
  _this.playbackPaused = true;
  _this.playbackInProgress = false;
  _this.update();
  _eventTracking2.default.track({
    category: 'Notifications',
    action: 'Playback',
    label: 'Pause Playback'
  });
};

this.handleStopPlayback = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (_historyUi.hui.inPlayback) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt('return');

          case 2:

            clearTimeout(_this.playbackTimeout);
            _this.playbackInProgress = false;
            _this.playbackPaused = false;
            _this.playbackStopped = true;
            _this.update();

            _historyUi.hui.leavePlaybackMode();
            canvas.fitMapContents();
            _eventTracking2.default.track({
              category: 'Notifications',
              action: 'Playback',
              label: 'Stop Playback'
            });

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function (_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var _freshenTimeout = false;
this.updateSlider = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
  var pointer;
  return regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (_freshenTimeout) clearTimeout(_freshenTimeout);
          if (_this.playbackTimeout) clearTimeout(_this.playbackTimeout);
          _this.playbackPaused = true;
          _this.playbackInProgress = false;
          _historyUi.hui.enterPlaybackMode();
          _this.update();
          pointer = _this.refs.slider.value;

          _this.playbackPointer = pointer;
          _context4.next = 10;
          return _historyUi.hui.shiftHistory({ to: pointer, deferUpdate: true });

        case 10:
          _freshenTimeout = setTimeout(function () {
            appUI.freshen();
            _historyUi.hui.zoomToCurrentOperation();
            _freshenTimeout = false;
            _eventTracking2.default.track({
              category: 'Notifications',
              action: 'Playback',
              label: 'Slider Click'
            });
          }, 200);

        case 11:
        case 'end':
          return _context4.stop();
      }
    }
  }, _callee4, _this);
}));

this.handleScroll = function (event) {
  return event.stopPropagation();
};

this.on('mount', function () {
  if (window.recentActivity) {
    _historyUi.hui.setRecentActivity(window.recentActivity);
    _this.playbackPointer = _historyUi.hui.operationLog.length - 1;
    canvas.appHeaderTag.update();
  }
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('notifications')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/notifications.html
// module id = 767
// module chunks = 0